/* eslint-disable no-unused-vars */
import React from 'react'
import "./Footer.css"
import images from '../../Asset/Img/img'
import FooterLogo from '../FooterLogo/FooterLogo';
import FooterDefault from '../FooterDefault/FooterDefault';

function Footer({ location }) {


  return (
    <div className='footer-container'>

{
 location !== "/contact" ? <FooterDefault/> : <FooterLogo />
 }

    </div>
  )
}

export default Footer


// {
//   location !== "/contact" ? <FormDefault/> : <FooterLogo />
// }